/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Left_Left_Justify_Left_PosInputs */



/**
* | output |
* | --- |
* | "Left Justify / Left Position" |
*
* @param {Align_Left_Left_Justify_Left_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_left_left_justify_left_pos = /** @type {((inputs?: Align_Left_Left_Justify_Left_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Left_Left_Justify_Left_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Justification Gauche / Position Gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Linksbündig / Linksposition")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giustifica a sinistra / Posizione a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выравнивание по левому краю / Позиция по левому краю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Justificar a la izquierda / Posición izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左对齐 / 左对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左揃え / 左配置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाएँ संरेखित करें / बाएँ स्थिति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Justificar à esquerda / Posicionamento à esquerda")
	return /** @type {LocalizedString} */ ("Left Justify / Left Position")
});